import { STORE_PRODUCT_CUSTOM_LEVEL } from '../../Product/S/constant.js';

export const getCustomLevelFromBox = () => {
  return box.sel('custom_level') ?? STORE_PRODUCT_CUSTOM_LEVEL.STATIC;
};
